var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('veui-dialog',{attrs:{"overlay-class":_vm.previewOverlayClass,"title":"","open":true,"footless":true,"closable":false}},[_c('div',{staticClass:"close-btn",on:{"click":_vm.close}}),_c('div',{staticClass:"content"},[_c('img',{staticClass:"demo-pic",attrs:{"src":_vm.pic,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }